import { render, staticRenderFns } from "./FormOptionEmptyPage.vue?vue&type=template&id=c77061c8&"
import script from "./FormOptionEmptyPage.vue?vue&type=script&lang=js&"
export * from "./FormOptionEmptyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports